import styled, { keyframes } from "styled-components"

export const fadeScaleIn = keyframes`
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
`

export const TriggerButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  background: none;
  border: none;
  color: ${({ theme }) => theme.primaryText};
  cursor: pointer;
  font-family: ${({ theme }) => theme.typography.fontFamily};
  font-size: ${({ theme }) => theme.typography.fontSize.md};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  transition:
    background-color 0.2s ease,
    transform 0.2s ease;
  &:hover {
    background-color: ${({ theme }) => theme.lightGrey};
    /* transform: scale(1.02); */
  }
`

export const PanelContainer = styled.div`
  position: absolute;
  top: 120%;
  right: 0;
  min-width: 360px;
  z-index: 999;
  animation: ${fadeScaleIn} 0.2s ease forwards;
  transform-origin: top right;
  background: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.medium};
  box-shadow: ${({ theme }) => theme.components.boxShadow.large};
  padding: ${({ theme }) => theme.spacing.md};
  /* left: 50%;
  transform: translateX(-50%) !important; */

  @media (max-width: 768px) {
    left: 50%;
    transform: translateX(-50%) !important;
    width: 100%;
    min-width: fit-content;
    margin: 0 auto;
  }
`

export const PanelHeader = styled.div`
  padding-bottom: ${({ theme }) => theme.spacing.sm};
  border-bottom: 1px solid ${({ theme }) => theme.secondary};
`

export const InputField = styled.input`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

export const SelectField = styled.select`
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

export const MultiSelectContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  gap: ${({ theme }) => theme.spacing.xs};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

export const Divider = styled.div`
  height: 1px;
  background-color: ${({ theme }) => theme.secondary};
  margin: ${({ theme }) => theme.spacing.sm} 0;
`

export const SectionTitle = styled.div`
  padding: ${({ theme }) => theme.spacing.sm};
  font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.secondaryText};
  background: ${({ theme }) => theme.lightGrey};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.md};
  text-align: center;
`

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: ${({ theme }) => theme.spacing.sm};
`

// We remove the "Apply" button since changes are reactive.
export const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${({ theme }) => theme.link};
  cursor: pointer;
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.xs};
  margin-bottom: ${({ theme }) => theme.spacing.sm};
`

export const Label = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
  color: ${({ theme }) => theme.secondaryText};
`

export const NumericInput = styled.input`
  width: 50px;
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`

export const DateInput = styled.input`
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border: 1px solid ${({ theme }) => theme.secondary};
  border-radius: ${({ theme }) => theme.components.borderRadius.small};
  font-size: ${({ theme }) => theme.typography.fontSize.sm};
`
